export default {
  name: 'Letter',

  props: ['type', 'price', 'title'],

  render () {
    const { type, price, title } = this
    // console.log(type)
    switch (type) {
      case 1: {
        return (
          <p>{`时长不代表深度，但每一分的积累都值得尊重。发现一门好课赠予你：《${title}》`}</p>
        )
      }
      case 2: {
        return (
          <p>{`你是我最铁的搭档，感谢你和我并肩作战，感谢你给我金玉良言，送你价值${price}元的《${title}》，2018年，我们一起闯！`}</p>
        )
      }
      case 3: {
        return (
          <p>{`2018年我想和你共同完成一件事情，那就是：学习《${title}》。探寻未知的激情，打开新事物的美好，此刻，我只愿与你共享！`}</p>
        )
      }
      default: break
    }
  }
}
